import { Component, Injector, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { BaseComponent } from '../../base.component';
import { ReportEventService } from "../../../Services/report-event/report-event.service";
import { forEach } from 'lodash';

@Component({
  selector: 'sidebar-panel',
  template: `
    <!-- For mobile resolution < 1000px -->
    <a class="sideBarNavBtnPanelClosebtn" (click)="toggleMenu()" [@CloseSlideInOut]="menuState">
      <img class="sidebar-panel-close" src="assets/images/icons/sidebar-panel-close.png">
    </a><!--

    --><div id="sideBarNavBtnPanel" [@slideInOut]="menuState" *ngIf="progressMeter" >
      <div class="container">
        <ul class="sections">
          <li
            class="section"
            [attr.aria-hidden]="isDisabled(myState)"
            [attr.aria-disabled]="isDisabled(myState)"
            [ngClass]="{
              completed: section.completed,
              active: section.active,
              inactive: !section.active,
              notcompletedli: !section.completed && !section.active,
              currentli: !section.completed && section.active
            }"
            *ngFor="let section of sections; let index = index"
          >
            <span
              [ngClass]="{ futuremeter: !section.completed && !section.active }"
            >
              <div class="section-wrapper" *ngIf="section.visible">
                <a
                  class="title-section"
                  [tabindex]="isDisabled(myState) ? -1 : 0"
                  [ngClass]="{
                    active: section.active,
                    inactive: !section.active,
                    completed: section.completed,
                    notcompleted: !section.completed && !section.active,
                    current: !section.completed && section.active
                  }"
                  [attr.name]="section.title"
                  (click)="
                    onClick(
                      progressMeter.name,
                      section.ajaxInfo.action,
                      section.ajaxInfo.stage,
                      section.completed,
                      $event
                    )
                  "
                  gtm-handler
                  events="click"
                  handlerType="button"
                  label="{{ section.ajaxInfo.stage }} + '_Navigation'"
                  action="LinkClick"
                  [attributeVal]="section.ajaxInfo.stage + '_Navigation'"
                  [attr.data-content]="index + 1"
                >
                  {{ section.title }}
                </a>
              </div>
            </span>
          </li>
        </ul>
      </div>
    </div>
  `,
  styleUrls: ['./sidebarpanel.component.scss'],
  animations: [
    trigger('slideInOut', [
      state(
        'in',
        style({ transform: 'translate3d(0,0,0)', position: 'fixed', left: '0%', width: '100%' })
      ),
      state(
        'out',
        style({ transform: 'translate3d(100%,0, 0)', position: 'fixed', left: '-200%', width: '100%' })
      ),
      transition('in => out', animate('500ms ease-in-out')),
      transition('out => in', animate('500ms ease-in-out'))
    ]),
    trigger('CloseSlideInOut', [
      state(
        'in',
        style({ transform: 'translate3d(0,0,0)', position: 'fixed', right: '7%', })
      ),
      state(
        'out',
        style({ transform: 'translate3d(100%,0, 0)', position: 'fixed', left: '-200%', width: '100%' })
      ),
      transition('in => out', animate('500ms ease-in-out')),
      transition('out => in', animate('500ms ease-in-out'))
    ])
  ]
})
export class SideBarPanelComponent extends BaseComponent implements OnInit {
  progressMeter: any;
  model: data;
  isOpen = false;
  sectionsList: any;
  ajaxInfo: any;
  totlLen = 0;
  menuState = 'out';
  detail: any;
  sections: section[];
  myState = state;

  constructor(
    private injector: Injector,
    private reportEvent: ReportEventService
  ) {
    super(injector);
  }

  ngOnInit() {
    this.layoutService.staticLayout.subscribe(data => {
      if (data) {
        this.model = data.data;
        this.progressMeter = this.model.metadata.progressMeter;

        this.sections = [];
        if (this.progressMeter) {
          this.addSections(this.progressMeter.sections, false);
        }
      }
    });

    this.observablesService.openSidebar.subscribe(isOpen => {
      if (isOpen) {
        this.toggleMenu();
        this.isOpen = isOpen;
      }
    });
  }

  addSections(sections: any[], isSubStates) {
    forEach(sections, section => {
      if (isSubStates) {
        section.visible = true;
      }
      this.sections.push(section);
      if (this.hasSubStates(section)) {
        this.addSections(section.states, true);
      }
    });
  }
  getIconClass(section) {
    if (section.completed) {
      return 'icon-progressmeter-checkmark';
    }
    return (
      `icon-progressmeter-${section.icon}` || 'icon-progressmeter-checkmark'
    );
  }
  setTitle(elem) {
    if (elem) {
      if (!elem.active && !elem.completed) {
        return 'disabled';
      }
    }
  }

  isDisabled(elem) {
    return this.setTitle(elem) === 'disabled';
  }

  hasSubStates(section) {
    return section.states;
  }

  /*
  checkActive(data) {
    this.detail = data.data.metadata.progressMeter.sections;
    forEach(this.detail, (currElement, index) => {
      //console.log("index : ", index+1, currElement.title);
      if (currElement.active) {
       this
      }
    });

  } */

  onClick = (elementSrc, action, stage, completed, event) => {
    const findClass = event.target.className;
    const splittedClassArray = findClass.split(' ');
    this.ajaxInfo = {
      action,
      stage
    };

    this.reportEvent.addPageLoad("none");

    this.isOpen = false;
    if (splittedClassArray.find(x => x === 'notcompleted')) {
      event.preventDefault();
    } else {
      this.toggleMenu();
    }
    return (
      completed &&
      this.actionService.ajaxAction(this.ajaxInfo, 'page', elementSrc)
    );
  }

  toggleMenu() {

    if (this.menuState === 'out') {
      this.menuState = 'in';
    } else {
      this.observablesService.openSidebar.next(false);
      this.menuState = 'out';
    }

  }
}
